import { CommonModule } from '@angular/common';
import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { BaseWidget } from '../base-widget/base-widget';
import { FormTypeEnum } from '../../core/enums/form-type.enum';
import { BusinessRegistrationDynamicFormComponent } from './business-registration-dynamic-form/business-registration-dynamic-form.component';
import { FeedbackFormComponent } from './feedback-form/feedback-form.component';
import { IBCreditFormComponent } from './ib-credit-form/ib-credit-form.component';

@Component({
  selector: 'forms',
  standalone: true,
  imports: [
    CommonModule,
    BusinessRegistrationDynamicFormComponent,
    FeedbackFormComponent,
    IBCreditFormComponent,
  ],
  templateUrl: './form.component.html',
  styleUrl: './form.component.scss',
})
export class FormComponent extends BaseWidget implements OnInit {
  @HostBinding('class') @Input() ngClass: any;
  @HostBinding('style') @Input() ngStyle: any;

  @Input() actionEvent: (event: any) => void;
  @Input() slot: any;
  data: any;
  formType = FormTypeEnum;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.data = this.slot.widget.data;
  }
}
